import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, FeatureGroup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import { EditControl } from "react-leaflet-draw";
import "leaflet-draw";
import {Col, Container, Row} from "react-bootstrap";

const Leaflet = ({
  setAreaState,
  defaultAreaLatLng,
  zoom = 6,
}: {
  setAreaState: (latLngs: { lat: number; lng: number }[] | undefined) => void;
  areaState: { lat: number; lng: number }[];
  defaultAreaLatLng: [number, number];
  zoom?: number;
}) => {
  const [editableFG, setEditableFG] = useState<any>(null);
  const mapRef: any = React.createRef();

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setView(
        [defaultAreaLatLng[0] || 36.92448, defaultAreaLatLng[1] || 50.641372],
        zoom
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultAreaLatLng]);

  const onCreated = (e: any) => {
    const layerType = e.layerType;
    const layer = e.layer;

    if (layerType === "polygon") {
      const latLngs = layer.getLatLngs()[0].map((latlng: any) => ({
        lat: latlng.lat,
        lng: latlng.lng,
      }));
      setAreaState(latLngs);
    }

    if (layerType === "marker") {
      const { lat, lng } = layer.getLatLng();
      setAreaState([{ lat, lng }]);
      if (editableFG) {
        Object.values(editableFG._layers).forEach((layer: any) => {
          editableFG.removeLayer(layer);
        });
        editableFG.addLayer(layer);
      }
    }
  };

  const onFeatureGroupReady = (reactFGref: any) => {
    setEditableFG(reactFGref);
  };

  useEffect(() => {
    const fetchPolygon = async () => {
      try {
        const res = await fetch("http://localhost:3000/api/polygon/your-id");
        const data = await res.json();
        const latlngs = data.coordinates[0].map(([lng, lat]: [number, number]) => ({
          lat,
          lng,
        }));
        setAreaState(latlngs);

        if (editableFG && editableFG._layers) {
          // Clear existing layers
          Object.values(editableFG._layers).forEach((layer: any) => {
            editableFG.removeLayer(layer);
          });

          // Add new polygon layer
          const L = require("leaflet");
          const newPolygon = L.polygon(latlngs);
          editableFG.addLayer(newPolygon);
        }
      } catch (err) {
        console.error("Error loading polygon", err);
      }
    };

    fetchPolygon().then((): boolean => false);
  }, [editableFG, setAreaState]);

  const onDrawDelete = (e: any) => {
    setAreaState(undefined);
  };

  return (
    <Container>
      <Row className="map-modal-container">
        <Col id="map-holder" style={{height: '35vh'}}>
          <MapContainer
            ref={mapRef}
            center={defaultAreaLatLng}
            zoom={6}
            zoomControl={false}
          >
            <TileLayer
              attribution='© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
            />
            <FeatureGroup
              ref={(featureGroupRef) => {
                onFeatureGroupReady(featureGroupRef);
              }}
            >
              <EditControl
                draw={{
                  marker: true,
                  circle: false,
                  polygon: true, // areaState === undefined ? true : false,
                  polyline: false,
                  rectangle: false,
                  circlemarker: false,
                }}
                position="topright"
                onCreated={onCreated}
                onDeleted={onDrawDelete}
                // edit={{
                //   featureGroup: editableFG,
                //   edit: {},
                //   remove: false,
                // }}
              />
            </FeatureGroup>
          </MapContainer>
        </Col>
      </Row>
    </Container>
  );
};
export default Leaflet;
